import AirLegWiseCo2Emission from 'src/app/flights/shared/AirLegWiseCo2Emission';
import { OBTFeatureConfigObtFeatureTypeEnum } from 'obt-common';
import { getFeatureVisibility } from 'obt-common/hooks/Flights/useGetAirSearchResultsFeatures';
import useAirSelectedItineraryManager from '../hooks/useAirSelectedItineraryManager';
import useAirSearchResultsFeaturesResponse from '../hooks/useAirSearchResultsFeaturesResponse';

/**
 * Renders emissions info based on selected itinerary
 */
const EmissionsInfoContainer = () => {
  const airSelectedItineraryResponseManager = useAirSelectedItineraryManager();

  const airSearchResultsFeatures = useAirSearchResultsFeaturesResponse();

  const isCo2PercentageEnabled = getFeatureVisibility(
    airSearchResultsFeatures,
    OBTFeatureConfigObtFeatureTypeEnum.Co2EmissionPercentage,
  );

  return (
    <AirLegWiseCo2Emission
      airSelectedItineraryResponseManager={airSelectedItineraryResponseManager}
      isCo2PercentageEnabled={isCo2PercentageEnabled}
    />
  );
};

export default EmissionsInfoContainer;
